var MetaFormModel = /** @class */ (function () {
    function MetaFormModel(layoutModel, requiredMetaFieldIds, metaFields, languages, wfStateMetaField, formType, formId, dePermission, childClassifiers) {
        this.layoutModel = layoutModel;
        this.requiredMetaFieldIds = requiredMetaFieldIds;
        this.metaFields = metaFields;
        this.languages = languages;
        this.wfStateMetaField = wfStateMetaField;
        this.formType = formType;
        this.formId = formId;
        this.dePermission = dePermission;
        this.childClassifiers = childClassifiers;
    }
    return MetaFormModel;
}());
export { MetaFormModel };
//# sourceMappingURL=meta-form.model.js.map